import { render } from "./ContactItemView.vue?vue&type=template&id=48d7964c"
import script from "./ContactItemView.vue?vue&type=script&lang=js"
export * from "./ContactItemView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__